import { Markdown } from '@/components/chat/Markdown';

interface Props {
  source: string;
}

/** 기존 Markdown 컴포넌트를 그대로 재사용. 패널 패딩만 추가. */
export function MarkdownArtifact({ source }: Props) {
  return (
    <div className="h-full overflow-auto bg-surface px-6 py-5">
      <div className="mx-auto max-w-3xl">
        <Markdown content={source} />
      </div>
    </div>
  );
}
